import { useContext } from 'react'

import { config } from '@/config'
import { CurrentUserContext } from '@/contexts'

export const useCurrentUser = () => {
  const { currentUser, isLoading } = useContext(CurrentUserContext)

  const userRole = currentUser?.role?.name

  const isSuperAdmin = userRole === config.roles.superAdmin

  const isAdmin = isSuperAdmin || userRole === config.roles.admin

  const isUser = isAdmin || userRole === config.roles.user

  const isViewer = isUser || userRole === config.roles.viewer

  const isGuest = !isViewer

  const isInternal = !!currentUser?.email?.endsWith('@dnv.com')

  const hasAccessToApi = !!currentUser?.organization?.hasAccessToApi

  return {
    currentUser,
    isLoading,
    isSuperAdmin,
    isAdmin,
    isUser,
    isViewer,
    isGuest,
    isInternal,
    hasAccessToApi
  }
}
